import { createLazyComponent } from './components/LazyRoute';

// 首页 - 保持同步加载（首屏关键）
import Home from './pages/Home';

// 其他页面 - 懒加载
const Product = createLazyComponent(() => import('./pages/Product'));
const Cases = createLazyComponent(() => import('./pages/Cases'));
const AboutUs = createLazyComponent(() => import('./pages/AboutUs'));
const ProductDetail = createLazyComponent(() => import('./pages/Product/detail'));
const ProductCategory = createLazyComponent(() => import('./pages/Product/product-category'));
const Solution = createLazyComponent(() => import('./pages/solution'));
const SolutionDetail = createLazyComponent(() => import('./pages/solution/detail'));
const ArticleDetail = createLazyComponent(() => import('./pages/ArticleDetail'));
const ActivityDetail = createLazyComponent(() => import('./pages/Activity/detail'));
const MediaDetail = createLazyComponent(() => import('./pages/Media/detail'));
const Services = createLazyComponent(() => import('./pages/Services'));
const JoinUs = createLazyComponent(() => import('./pages/JoinUs'));
const CaseDetail = createLazyComponent(() => import('./pages/Cases/case-detail'));
const Go1688 = createLazyComponent(() => import('./pages/Go1688'));
const GoSupplier = createLazyComponent(() => import('./pages/Go1688/supplier'));
const GoPurchaser = createLazyComponent(() => import('./pages/Go1688/purchaser'));
const NotFound = createLazyComponent(() => import('./components/NotFound'));
const Periodical = createLazyComponent(() => import('./pages/Periodical'));
const PeriodicalDetail = createLazyComponent(() => import('./pages/Periodical/detail'));
const Activity = createLazyComponent(() => import('./pages/Activity'));
const Media = createLazyComponent(() => import('./pages/Media'));
const AI = createLazyComponent(() => import('./pages/ai'));
const AIScene = createLazyComponent(() => import('./pages/ai/scene'));
const AipProductEntry = createLazyComponent(() => import('./pages/AIP/product'));
const AipSolutionEntry = createLazyComponent(() => import('./pages/AIP/solution'));
// AI-SRM 页面为同步加载（首屏即内容页，需 SSR 直出正文以利于收录）
import AiSrm from './pages/Product/ai-srm';
import AiSrmScene from './pages/Product/ai-srm/scene';
import AIPDetail from './components/AIP/detail';

const config = [
  {
    path: '/',
    exact: true,
    component: Home
  },
  {
    path: '/product-category/:id',
    exact: true,
    component: ProductCategory
  },
  {
    path: '/product',
    exact: true,
    component: Product
  },
  // AI-SRM 前端固定页（数据为本地常量，非 CMS 驱动），必须位于 /product/:id 之前
  {
    path: '/product/ai-srm',
    exact: true,
    component: AiSrm
  },
  {
    path: '/product/ai-srm/scene/:sceneKey',
    exact: true,
    component: AiSrmScene
  },
  {
    // sceneKey 缺失或非法时由组件内部重定向到默认场景
    path: '/product/ai-srm/scene',
    exact: true,
    component: AiSrmScene
  },
  {
    path: '/product/:id',
    exact: true,
    component: ProductDetail
  },
  {
    path: '/solution',
    exact: true,
    component: Solution
  },
  {
    path: '/solution/:id',
    exact: true,
    component: SolutionDetail
  },
  {
    path: '/cases',
    exact: true,
    component: Cases
  },
  {
    path: '/about-us',
    exact: true,
    component: AboutUs
  },
  {
    path: '/about-us/:type',
    exact: true,
    component: AboutUs
  },
  {
    path: '/about-us/:type/:id/preview',
    exact: true,
    component: AboutUs
  },
  {
    path: '/about_us',
    exact: true,
    component: AboutUs
  },
  {
    path: '/article-detail/:type/:id',
    exact: true,
    component: ArticleDetail
  },
  {
    path: '/article-detail/:type/:id/preview',
    exact: true,
    component: ArticleDetail
  },
  {
    path: '/case-detail/:id',
    exact: true,
    component: CaseDetail
  },
  {
    path: '/form/:id',
    exact: true,
    component: Home
  },
  {
    path: '/form/:id/preview',
    exact: true,
    component: Home
  },
  {
    path: '/services',
    exact: true,
    component: Services
  },
  {
    path: '/services/:id/preview',
    exact: true,
    component: Services
  },
  {
    path: '/join-us',
    exact: true,
    component: JoinUs
  },
  {
    path: '/join-us/:id/preview',
    exact: true,
    component: JoinUs
  },
  {
    path: '/periodical',
    exact: true,
    component: Periodical
  },
  {
    path: '/periodical/:id',
    exact: true,
    component: PeriodicalDetail
  },
  {
    path: '/go1688',
    exact: true,
    component: Go1688
  },
  {
    path: '/activity',
    exact: true,
    component: Activity
  },
  {
    path: '/activity/:id',
    exact: true,
    component: ActivityDetail
  },
  {
    path: '/media',
    exact: true,
    component: Media
  },
  {
    path: '/Media/:id',
    exact: true,
    component: MediaDetail
  },
  {
    path: '/go1688/purchaser',
    exact: true,
    component: GoPurchaser
  },
  {
    path: '/go1688/supplier',
    exact: true,
    component: GoSupplier
  },
  {
    path: '/ai',
    exact: true,
    component: AI
  },
  {
    path: '/ai/scene',
    exact: true,
    component: AIScene
  },
  {
    path: '/ai/*',
    exact: true,
    component: AI
  },
  {
    path: '/aip/:id',
    exact: true,
    component: AIPDetail
  },
  {
    path: '/aip/product/:productName',
    exact: true,
    component: AipProductEntry
  },
  {
    path: '/aip/solution/:solutionName',  
    exact: true,
    component: AipSolutionEntry
  },
  {
    path: '*',
    component: NotFound
  }
];

export default config;
